import { SERVICE_COMPLETION_STATUS_TYPES } from "@routebot/constants";

export function checkIsPickUp(type) {
  if (!type) return true;
  return type.toString() === "100" || type.toString() === "PICK_UP";
}

export const SERVICE_COMPLETION_STATUS_TYPES_TR = [
  { value: SERVICE_COMPLETION_STATUS_TYPES.NONE, label: "-" },
  { value: SERVICE_COMPLETION_STATUS_TYPES.NO_SHOW, label: "No-Show" },
  { value: SERVICE_COMPLETION_STATUS_TYPES.TAXI, label: "Taksi" },
  { value: SERVICE_COMPLETION_STATUS_TYPES.FINISHED, label: "Standart" },
];

export const SERVICE_COMPLETION_STATUS_TYPES_EN = [
  { value: SERVICE_COMPLETION_STATUS_TYPES.NONE, label: "-" },
  { value: SERVICE_COMPLETION_STATUS_TYPES.NO_SHOW, label: "No-Show" },
  { value: SERVICE_COMPLETION_STATUS_TYPES.TAXI, label: "Taxi" },
  { value: SERVICE_COMPLETION_STATUS_TYPES.FINISHED, label: "Standard" },
];
